module.exports = __webpack_public_path__ + "static/img/6areaB_9.c6bcb02.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_9.png
// module id = 1221
// module chunks = 1